module.exports = __webpack_public_path__ + "static/media/Submit-claim.db337579.png";